import { useSyncExternalStore } from 'react';
import { useNavigationManager } from './hook.manager.js';

function useLocation() {
  const manager = useNavigationManager();
  return useSyncExternalStore(
    manager.subscribe,
    manager.getLocation,
    manager.getLocation
  );
}

export { useLocation };
//# sourceMappingURL=hook.location.js.map
